import { motion } from "framer-motion";
import { daysUntilChristmas } from "@/lib/christmas";

export default function HolidayBanner({ onShop }) {
  const { days, passed } = daysUntilChristmas();
  if (passed) return null;

  const label =
    days === 0
      ? "Merry Christmas!"
      : days === 1
      ? "1 sleep until Christmas"
      : `${days} sleeps until Christmas`;

  return (
    <motion.aside
      initial={{ opacity: 0, y: -8 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="relative overflow-hidden rounded-[24px] border border-[#F1D9DA] mb-10"
      style={{
        background:
          "linear-gradient(105deg, #FDF3EE 0%, #F8E3E5 45%, #F1D9DA 100%)",
      }}
      data-testid="holiday-banner"
    >
      {/* Soft snow / glow decoration */}
      <div
        aria-hidden
        className="pointer-events-none absolute -top-16 -right-10 w-56 h-56 rounded-full opacity-70 blur-3xl"
        style={{ background: "radial-gradient(#FFFFFF 0%, transparent 60%)" }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-20 -left-10 w-64 h-64 rounded-full opacity-60 blur-3xl"
        style={{ background: "radial-gradient(#F8C1B7 0%, transparent 60%)" }}
      />

      <div className="relative flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5 px-6 sm:px-10 py-6 sm:py-7">
        <div className="flex items-center gap-4 min-w-0">
          <div
            className="hidden sm:flex flex-shrink-0 items-center justify-center w-14 h-14 rounded-full bg-white/70 backdrop-blur border border-white/80 font-serif-me italic text-2xl text-[#B23A48]"
            aria-hidden
          >
            ✦
          </div>
          <div className="min-w-0">
            <div
              className="text-[10px] sm:text-[11px] tracking-[0.32em] uppercase text-[#B23A48]"
              data-testid="holiday-banner-eyebrow"
            >
              Holiday drop · Limited release
            </div>
            <h3 className="mt-1 font-serif-me text-2xl sm:text-3xl text-[#36292A] leading-[1.1]">
              Christmas Stocking Stuffer{" "}
              <span className="italic text-[#B23A48]">— just $8</span>
            </h3>
            <p className="mt-1.5 text-xs sm:text-sm text-[#7D6B6D]">
              A little bundle of joy for her tree. Flat $3 NZ-wide shipping.
            </p>
          </div>
        </div>

        <div className="flex items-center gap-4 sm:gap-5 flex-shrink-0">
          <div
            className="text-right"
            data-testid="holiday-banner-countdown"
            aria-label={label}
          >
            <div className="font-serif-me text-3xl sm:text-4xl text-[#B23A48] leading-none">
              {days}
            </div>
            <div className="mt-1 text-[9px] sm:text-[10px] tracking-[0.28em] uppercase text-[#7D6B6D]">
              {days === 1 ? "sleep to go" : "sleeps to go"}
            </div>
          </div>
          <button
            type="button"
            onClick={onShop}
            className="me-btn-primary whitespace-nowrap"
            style={{ backgroundColor: "#B23A48" }}
            data-testid="holiday-banner-cta"
          >
            Shop the drop
            <span aria-hidden>→</span>
          </button>
        </div>
      </div>
    </motion.aside>
  );
}
